// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sh-pricing__title {\n  margin-bottom: 20px;\n  font-weight: bold;\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
